// src/core/audio-player.js — helper compartido para reproducir audios de
// arenga (.webm) con header EBML Duration=0.
//
// Bug Duration=0 (fix e2c1100, 28-may-2026): MediaRecorder en algunos devices
// escribe el header con Duration=0 explícito. El browser en PROD respeta el
// header literal y no transiciona a "playing state" — el audio queda silente
// aunque .play() resuelva. Solución: bajar el archivo entero a un blob URL
// local; con todos los Clusters disponibles el browser computa la duración
// real y reproduce normal.
//
// Idempotente vía dataset.blobified. Defensivo: si el fetch falla, devuelve
// { ok:false, reason } y el caller sigue con el src original (no peor que
// antes del fix).

export const ensureBlobUrl = async (audioEl) => {
  if (!audioEl) return { ok: false, reason: 'sin elemento' }
  if (audioEl.dataset.blobified === '1') return { ok: true, cached: true }
  const originalSrc = audioEl.getAttribute('src')
  if (!originalSrc) return { ok: false, reason: 'sin src' }
  // Fix freeze-mobile (6-jun): timeout duro de 15s (AbortController + setTimeout,
  // sin AbortSignal.timeout por WebView viejo). En celu con conexión muerta, bajar
  // el .webm colgaba el play en "Pausa" para siempre. Al abortar → { ok:false,
  // reason:'timeout' } y el caller degrada (reproduce el src original / resetea).
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), 15000)
  try {
    const r = await fetch(originalSrc, { signal: controller.signal })
    if (!r.ok) return { ok: false, reason: `HTTP ${r.status}` }
    const blob = await r.blob()
    const blobUrl = URL.createObjectURL(blob)
    audioEl.dataset.blobified = '1'
    audioEl.dataset.blobUrl = blobUrl
    audioEl.src = blobUrl
    audioEl.load()
    return { ok: true, blobUrl }
  } catch (err) {
    const aborted = err?.name === 'AbortError' || controller.signal.aborted
    return { ok: false, reason: aborted ? 'timeout' : (err?.message || String(err)) }
  } finally {
    clearTimeout(timer)
  }
}

export const revokeBlobUrl = (audioEl) => {
  if (!audioEl) return
  const url = audioEl.dataset.blobUrl
  if (url) {
    try { URL.revokeObjectURL(url) } catch (_) {}
    delete audioEl.dataset.blobUrl
    delete audioEl.dataset.blobified
  }
}
